import { FC } from 'react';
import { profileTaskOverdueSlice } from '../../store/profileReports';
import OverdueReport from './OverdueReport';
import { ProfileDateRangeProps } from './useProfileDateRange';

interface TaskOverdueReportProps extends ProfileDateRangeProps {
  userUuid: string;
}

const TaskOverdueReport: FC<TaskOverdueReportProps> = ({ userUuid, dateRange, onDateRangeChange }) => (
  <OverdueReport
    storeSlice={profileTaskOverdueSlice}
    userUuid={userUuid}
    dateRange={dateRange}
    onDateRangeChange={onDateRangeChange}
    rowKey="task_uuid"
    titleColumn={{ title: 'Task', dataIndex: 'task_title' }}
    searchField="task_title"
    searchPlaceholder="Search task"
    eventDate={{ title: 'End date', single: 'end_date', old: 'old_end_date', next: 'new_end_date' }}
    countLabel="entries"
    headerTitle="Task overdue report"
    headerSubtitle="Tasks that have been overdue with their events"
  />
);

export default TaskOverdueReport;
